/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { DestinationTransportDto } from '../models/destination-transport-dto';
import { LoadResult } from '../models/load-result';


/**
 * Fonctions de gestion des destinations de transport
 */
@Injectable({
  providedIn: 'root',
})
export class DestinationTransportService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation destinationTransportGetList
   */
  static readonly DestinationTransportGetListPath = '/api/destination-transport/list';

  /**
   * Renvoie la liste des destinations de transport.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `destinationTransportGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  destinationTransportGetList$Response(params?: {
  }): Observable<StrictHttpResponse<Array<DestinationTransportDto>>> {

    const rb = new RequestBuilder(this.rootUrl, DestinationTransportService.DestinationTransportGetListPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<DestinationTransportDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des destinations de transport.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `destinationTransportGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  destinationTransportGetList(params?: {
  }): Observable<Array<DestinationTransportDto>> {

    return this.destinationTransportGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<DestinationTransportDto>>) => r.body as Array<DestinationTransportDto>)
    );
  }

  /**
   * Path part for operation destinationTransportLoadList
   */
  static readonly DestinationTransportLoadListPath = '/api/destination-transport/load-list';

  /**
   * Renvoie la liste des destinations de transport (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `destinationTransportLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  destinationTransportLoadList$Response(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, DestinationTransportService.DestinationTransportLoadListPath, 'post');
    if (params) {
      rb.query('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des destinations de transport (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `destinationTransportLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  destinationTransportLoadList(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.destinationTransportLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation destinationTransportGet
   */
  static readonly DestinationTransportGetPath = '/api/destination-transport/{id}';

  /**
   * Renvoie la destination de transport spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `destinationTransportGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  destinationTransportGet$Response(params: {

    /**
     * Identifiant de la destination de transport
     */
    id: number;
  }): Observable<StrictHttpResponse<DestinationTransportDto>> {

    const rb = new RequestBuilder(this.rootUrl, DestinationTransportService.DestinationTransportGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DestinationTransportDto>;
      })
    );
  }

  /**
   * Renvoie la destination de transport spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `destinationTransportGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  destinationTransportGet(params: {

    /**
     * Identifiant de la destination de transport
     */
    id: number;
  }): Observable<DestinationTransportDto> {

    return this.destinationTransportGet$Response(params).pipe(
      map((r: StrictHttpResponse<DestinationTransportDto>) => r.body as DestinationTransportDto)
    );
  }

  /**
   * Path part for operation destinationTransportPost
   */
  static readonly DestinationTransportPostPath = '/api/destination-transport';

  /**
   * Crée la destination de transport spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `destinationTransportPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  destinationTransportPost$Response(params: {

    /**
     * Destination de transport
     */
    body: DestinationTransportDto
  }): Observable<StrictHttpResponse<DestinationTransportDto>> {

    const rb = new RequestBuilder(this.rootUrl, DestinationTransportService.DestinationTransportPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DestinationTransportDto>;
      })
    );
  }

  /**
   * Crée la destination de transport spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `destinationTransportPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  destinationTransportPost(params: {

    /**
     * Destination de transport
     */
    body: DestinationTransportDto
  }): Observable<DestinationTransportDto> {

    return this.destinationTransportPost$Response(params).pipe(
      map((r: StrictHttpResponse<DestinationTransportDto>) => r.body as DestinationTransportDto)
    );
  }

}
